import { render, staticRenderFns } from "./WorkingUnsolvedExportTakeout.vue?vue&type=template&id=0a2cb162"
import script from "./WorkingUnsolvedExportTakeout.vue?vue&type=script&lang=js"
export * from "./WorkingUnsolvedExportTakeout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a2cb162')) {
      api.createRecord('0a2cb162', component.options)
    } else {
      api.reload('0a2cb162', component.options)
    }
    module.hot.accept("./WorkingUnsolvedExportTakeout.vue?vue&type=template&id=0a2cb162", function () {
      api.rerender('0a2cb162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/WorkingUnsolvedExportTakeout.vue"
export default component.exports